export const STREAM_MODE = {
    MESSAGE_FORMAT_PLUS: "message_format_plus", //  message_format_plus 模式
    FULL_THOUGHTS: "full_thoughts", // full_thoughts 模式
};

export const currentStreamMode = STREAM_MODE.MESSAGE_FORMAT_PLUS;